import {Injectable} from '@angular/core';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import {AngularFirestore} from 'angularfire2/firestore';


@Injectable()
export class StripePaymentService {


  uid: string;
  membership: boolean;

  constructor(private firestore: AngularFirestore) {
  }


  /**
   * Check Membership Status
   * @returns {Observable<{}>}
   */
  retrieveMembership() {
    const org_id = localStorage.getItem('org_id');
    const membershipStatus = this.firestore.collection('organizations').doc(org_id).collection('membership').doc('status');
    return membershipStatus.valueChanges();
  }


  /**
   *
   * @returns {Observable<{}>}
   */
  retrieveToken() {
    const org_id = localStorage.getItem('org_id');
    const membershipStatus = this.firestore.collection('organizations').doc(org_id).collection('membership').doc('token');
    return membershipStatus.valueChanges();
  }


  /**
   *
   * @param token
   * @returns {Promise<void>}
   */
  processPayment(token: any) {
    const org_id = localStorage.getItem('org_id');
    return this.firestore.collection('organizations').doc(org_id).collection('membership').doc('token')
      .set({token: token.id});

  }

}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/other/stripe-payment.service.ts